export const API_CONFIG = {
  baseUrl: import.meta.env.VITE_KODIAK_API_URL || 'https://backend.kodiak.finance',
  timeout: 30000,
} as const

export const API_ENDPOINTS = {
  balances: (tokenId: string) => `/balances/${tokenId}`,
  blocks: '/blocks',
  vaults: '/vaults',
  vault: (vaultId: string) => `/vaults/${vaultId}`,
  farms: '/farms',
  tokens: '/tokens',
  token: (tokenId: string) => `/tokens/${tokenId}`,
  quote: '/quote',
} as const
